module.exports = __webpack_public_path__ + "img/sec3_2.35080bfc.png";